import { IonCol, IonIcon, IonRow } from "@ionic/react";
import { play, playSkipBack, playSkipForward } from "ionicons/icons";
import { useMemo, useState } from "react";

interface IVideoListProps {
  onVideoEnded: () => void;
  videos: {
    link: string;
    _id: string;
    pictureUrl?: string;
    isViewed: boolean;
    name: string;
  }[];
}

export const VideoList: React.FC<IVideoListProps> = ({
  onVideoEnded,
  videos,
}) => {
  const [actualVideoIndex, setActualVideoIndex] = useState(0);

  const previousVideo = useMemo(() => {
    if (actualVideoIndex <= 0) return null;
    return videos[actualVideoIndex - 1];
  }, [actualVideoIndex, videos]);

  const nextVideo = useMemo(() => {
    if (actualVideoIndex >= videos.length - 1) return null;
    return videos[actualVideoIndex + 1];
  }, [actualVideoIndex, videos]);


  if(videos.length === 0){return <div>no videos</div>}

  return (
    <>
      {/* actual video */}
      <IonRow class="ion-justify-content-center">
        <IonCol>
          <video
            controls={true}
            controlsList="nodownload"
            className="video"
            src={videos[actualVideoIndex].link}
            onEnded={onVideoEnded}
          >
            <source
              src={videos[actualVideoIndex].link }
              type="video/mp4"
            />
          </video>
        </IonCol>
      </IonRow>

      {/* next and previous button */}
      <IonRow className="ion-justify-content-center">
        <IonCol
          size="3"
          size-lg="3"
          size-sm="3"
          className=" change-video-btn"
          id={!previousVideo ? "btn-disabled" : ""}
          onClick={() => {
            if (!previousVideo) return;
            setActualVideoIndex(actualVideoIndex - 1);
          }}
        >
          <div className="btn buttonVideo">
            <IonIcon
              className="black-text nextVideoButton live-hours-icon ion-justify-content-center"
              icon={playSkipBack}
            ></IonIcon>
          </div>
        </IonCol>
        <IonCol
          size="3"
          size-lg="3"
          size-sm="3"
          className=" change-video-btn"
          id={!nextVideo ? "btn-disabled" : ""}
          onClick={() => {
            if (!nextVideo) return;
            setActualVideoIndex(actualVideoIndex + 1);
          }}
        >
          <div className="btn buttonVideo">
            <IonIcon
              className="black-text nextVideoButton live-hours-icon"
              icon={playSkipForward}
            ></IonIcon>
          </div>
        </IonCol>
      </IonRow>

      {/* others videos */}
      <IonRow>
        <div className="otherVideos fullWidth">
          {videos.map((video, i) => (
            <IonCol
              key={i}
              size="5"
              size-lg="5"
              size-sm="5"
              className="black-text hover-underline"
              onClick={() => {
                setActualVideoIndex(i);
              }}
            >
              <IonRow className="fullWidth">
                <IonCol
                  key={i}
                  className={
                    "otherVideo " + (i === actualVideoIndex ? " current" : "")
                  }
                  style={{
                    position: "relative",
                    backgroundImage: "url('" + video.pictureUrl + "')",
                  }}
                >
                  {video.isViewed && i === actualVideoIndex && (
                    <img
                      alt=""
                      src="https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/thin-tic-removebg-preview.png"
                      className="valid-image"
                    />
                  )}
                  <IonIcon
                    className="black-text nextVideoButton play live-hours-icon"
                    icon={play}
                    color="secondary"
                  ></IonIcon>
                </IonCol>
              </IonRow>
              <IonRow className="black-text">{video.name}</IonRow>
            </IonCol>
          ))}
        </div>
      </IonRow>
    </>
  );
};
